import type { TableColumnType } from 'antd';
import type { ProdutoEstoqueRegistro } from '@/features/produto/util/estoque';
import { getProdutoEstoqueId } from '@/features/produto/util/estoque';
import { numberToString } from '@/std/format';
import { ProdutoSelectTable } from './ProdutoSelectTable';
import { getProdutoSelectEstoqueDescricao } from './produtoSelectUtil';

const columns: TableColumnType<ProdutoEstoqueRegistro>[] = [
    {
        key: 'local',
        render: (_, estoque) => getProdutoSelectEstoqueDescricao(estoque),
        title: 'Local de estoque',
    },
    {
        key: 'localizacao',
        render: (_, estoque) =>
            'ple_estoque_idpk' in estoque ? estoque.ple_localizacao : estoque.pre_localizacao,
        title: 'Localização',
    },
    {
        align: 'right',
        key: 'disponivel',
        render: (_, estoque) =>
            numberToString(
                'ple_estoque_idpk' in estoque
                    ? estoque.ple_estoque_disponivel
                    : estoque.pre_estoque_disponivel,
            ),
        title: 'Estoque disponível',
    },
];

export function ProdutoSelectModalLocal({
    estoques,
    localSelecionado,
    onSelect,
}: {
    estoques: ProdutoEstoqueRegistro[];
    localSelecionado?: ProdutoEstoqueRegistro | null;
    onSelect: (estoque: ProdutoEstoqueRegistro) => void;
}) {
    return (
        <ProdutoSelectTable
            columns={columns}
            data={estoques}
            emptyText='Nenhum local de estoque disponível para esta seleção.'
            initialSelectedRowKey={
                localSelecionado ? (getProdutoEstoqueId(localSelecionado) ?? 'padrao') : undefined
            }
            onSelect={onSelect}
            rowKey={(estoque) => getProdutoEstoqueId(estoque) ?? 'padrao'}
        />
    );
}
